<template>
  <div>
    <div class="flex items-center">
      <div class="flex-1 pr-4">
        <p>Divers</p>
        <p class="fs-12 text-black-light-5">Certified divers</p>
      </div>
      <div class="flex-none">
        <numeral-stepper-new v-model="divers" />
      </div>
    </div>

    <hr class="border-black-30 my-4" />

    <div class="flex items-center">
      <div class="flex-1 pr-4">
        <p>Student divers</p>
        <p class="fs-12 text-black-light-5">Beginner and advanced courses</p>
      </div>
      <div class="flex-none">
        <numeral-stepper-new v-model="studentDivers" />
      </div>
    </div>

    <hr class="border-black-30 my-4" />

    <div class="flex items-center">
      <div class="flex-1 pr-4">
        <p>Non-divers</p>
        <p class="fs-12 text-black-light-5">Snorkelers, children under 13…</p>
      </div>
      <div class="flex-none">
        <numeral-stepper-new v-model="nonDivers" />
      </div>
    </div>
  </div>
</template>

<script>
import NumeralStepperNew from '../NumeralStepperNew'

export default {
  components: {
    NumeralStepperNew
  },
  props: ['value'],
  data () {
    return {
      divers: this.value.divers,
      studentDivers: this.value.studentDivers,
      nonDivers: this.value.nonDivers
    }
  },
  methods: {
    handleEmit () {
      this.$emit('input', {
        divers: this.divers,
        studentDivers: this.studentDivers,
        nonDivers: this.nonDivers
      })
    }
  },
  watch: {
    divers () {
      this.handleEmit()
    },
    studentDivers () {
      this.handleEmit()
    },
    nonDivers () {
      this.handleEmit()
    }
  }
}
</script>